import { useEffect, useState } from 'react';

export default function AboutHero() {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setLoaded(true), 80);
    return () => clearTimeout(t);
  }, []);

  return (
    <section className="relative min-h-[60vh] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/bd0a3fc44e5ae90a4e2cf6325ab67cff.jpg"
          alt="CJ Solutions office"
          width={1440}
          height={900}
          loading="eager"
          fetchPriority="high"
          decoding="async"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-slate-900/70 via-slate-900/60 to-slate-900/75"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-32 pb-20 text-center">
        <span
          className={`inline-block px-4 py-1.5 bg-amber-500/20 border border-amber-400/40 text-amber-300 text-sm font-semibold uppercase tracking-widest rounded-full mb-6 transition-all duration-700 ${
            loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
          }`}
        >
          About Us
        </span>
        <h1
          className={`text-5xl sm:text-6xl lg:text-7xl font-semibold text-white leading-tight mb-6 transition-all duration-700 delay-150 ${
            loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          Built on Trust,<br />Driven by Expertise
        </h1>
        <p
          className={`text-xl text-white/80 max-w-2xl mx-auto leading-relaxed transition-all duration-700 delay-300 ${
            loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          Since 2023, CJ Solutions Ltd. has been helping businesses navigate complex regulatory landscapes with clarity, confidence, and precision.
        </p>
      </div>
    </section>
  );
}
